import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Table, TableHead, TableRow, TableCell, TableBody,
    CircularProgress, Box, TablePagination
} from "@material-ui/core";
import { useFindWagerHistoryQuery } from "../../../api/wager";

interface WagerHistoryDialogProps {
    open: boolean;
    onClose: () => void;
    hallId: number;
    wagerId: number | null;
}

export const WagerHistoryDialog: React.FC<WagerHistoryDialogProps> = ({ open, onClose, hallId, wagerId }) => {
    const [page, setPage] = useState(0);

    // При открытии нового вейджера сбрасываем страницу на 0
    useEffect(() => {
        if (open) {
            setPage(0);
        }
    }, [open, wagerId]);

    const { data, isFetching } = useFindWagerHistoryQuery(
        { hall_id: hallId, wager_id: wagerId!, page: page + 1 },
        { skip: !wagerId } // Запрос не уйдет, пока wagerId === null
    );

    const history = useMemo(() => data?.items || [], [data]);
    const meta = useMemo(() => data?.meta || { totalCount: 0, perPage: 20 }, [data]);

    const handleChangePage = useCallback((event: unknown, newPage: number) => {
        setPage(newPage);
    }, []);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>История ставок (Вэйджер #{wagerId})</DialogTitle>

            <DialogContent dividers style={{ padding: 0 }}>
                {/* Обертка для скролла, если контента много */}
                <Box style={{ overflowX: "auto" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID Спина</TableCell>
                                <TableCell>Дата</TableCell>
                                <TableCell>Session ID</TableCell>
                                <TableCell align="right">Ставка (Debit)</TableCell>
                                <TableCell align="right">Выигрыш (Credit)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isFetching && history.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center" style={{ padding: "24px" }}>
                                        <CircularProgress size={32} />
                                    </TableCell>
                                </TableRow>
                            ) : history.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">История пуста</TableCell>
                                </TableRow>
                            ) : (
                                history.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.id}</TableCell>
                                        <TableCell>{item.created_at}</TableCell>
                                        <TableCell>{item.session_id}</TableCell>
                                        <TableCell align="right">{item.debit / 100}</TableCell>
                                        <TableCell align="right">{item.credit / 100}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </DialogContent>

            <DialogActions style={{ justifyContent: "space-between" }}>
                <Box>
                    {meta.totalCount > 0 && (
                        <TablePagination
                            component="div"
                            count={meta.totalCount}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={meta.perPage}
                            rowsPerPageOptions={[meta.perPage]}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
                        />
                    )}
                </Box>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
};